import {Image, TopBar as MantineTopBar, useMantineColorScheme} from '@components/mantine';
import {UserMenu} from '@components/session';
import {UserContext} from '@core/user';
import {FunctionComponent, ReactNode, useContext} from 'react';
import {QuickNavigation} from '../navigation/QuickNavigation';
import {DarkModeSwitch} from './DarkModeSwitch';
import logoLight from './images/Coveo_Horizontal_Blue.svg';
import logoDark from './images/Coveo_Horizontal_White.svg';

interface TopBarProps {
    children: ReactNode;
}

export const TopBar: FunctionComponent<TopBarProps> = ({children}) => {
    const {colorScheme} = useMantineColorScheme();
    const userCtx = useContext(UserContext);

    return (
        <MantineTopBar>
            {children}
            <Image src={colorScheme === 'dark' ? logoDark : logoLight} h={34} fit="contain" alt="coveo logo" />
            <MantineTopBar.Right>
                <QuickNavigation />
                <DarkModeSwitch />
                {userCtx?.query?.data && <UserMenu showInternalSection={false} />}
            </MantineTopBar.Right>
        </MantineTopBar>
    );
};
